import WaveformTrack from "./WaveformTrack";

interface AudioDebugPanelProps {
  /** Input events log lines (mouse/keyboard) */
  debugLog: string[];
  /** WebSocket connection state label */
  connectionState: string;
  /** AnalyserNode at Y-Mixer input (WebRTC output) */
  analyserInput: AnalyserNode | null;
  /** AnalyserNode on speakers branch */
  analyserSpeakers: AnalyserNode | null;
  /** AnalyserNode on Gladia capture branch */
  analyserGladia: AnalyserNode | null;
  /** Whether Y-Mixer is active */
  monitoring: boolean;
  /** Callback to start the Y-Mixer (user gesture required) */
  onStartMonitor: () => void;
}

/**
 * Debug panel split vertically:
 *   LEFT  — mouse/keyboard input events log
 *   RIGHT — 3 stacked audio waveform tracks (5s scrolling)
 *           with a "Monitor" button if mixer not yet started
 */
export default function AudioDebugPanel({
  debugLog,
  connectionState,
  analyserInput,
  analyserSpeakers,
  analyserGladia,
  monitoring,
  onStartMonitor,
}: AudioDebugPanelProps) {
  return (
    <div
      style={{
        borderTop: "1px solid #333",
        background: "#0a0a0a",
        display: "flex",
        flexShrink: 0,
        height: 170,
        overflow: "hidden",
      }}
    >
      {/* LEFT — Input events */}
      <div
        style={{
          width: "40%",
          borderRight: "1px solid #222",
          padding: "6px 10px",
          fontFamily: "monospace",
          fontSize: 11,
          color: "#a3e635",
          overflowY: "auto",
        }}
      >
        <div style={{ color: "#555", marginBottom: 2 }}>
          Input — WS: {connectionState}
        </div>
        {debugLog.length === 0 ? (
          <div style={{ color: "#333" }}>Click or type on the video...</div>
        ) : (
          debugLog.map((line, i) => <div key={i}>{line}</div>)
        )}
      </div>

      {/* RIGHT — 3 waveform tracks */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          gap: 2,
          padding: "4px 6px",
          position: "relative",
        }}
      >
        {!monitoring && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10,
              background: "rgba(10, 10, 10, 0.85)",
            }}
          >
            <button
              onClick={onStartMonitor}
              style={{
                background: "#2563eb",
                color: "#fff",
                border: "none",
                borderRadius: 6,
                padding: "8px 20px",
                fontSize: 13,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Start Audio Monitor
            </button>
          </div>
        )}
        <WaveformTrack
          analyser={analyserInput}
          label="WebRTC input"
          color="#60a5fa"
          height={50}
        />
        <WaveformTrack
          analyser={analyserSpeakers}
          label="Speakers"
          color="#4ade80"
          height={50}
        />
        <WaveformTrack
          analyser={analyserGladia}
          label="Gladia"
          color="#f97316"
          height={50}
        />
      </div>
    </div>
  );
}
